import { render, staticRenderFns } from "./DataHeader.vue?vue&type=template&id=4dbb92ce&"
import script from "./DataHeader.vue?vue&type=script&lang=js&"
export * from "./DataHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports